<template>
  <div class="company-info box df fdc">
    <div class="company-info-top df fdr jcsb">
      <div class="image-box">
        <img v-bind:src="$store.getters.userData.companyImage ? $store.getters.userData.companyImage : '/images/HP_Logo.svg'" alt="" class="company-logo">
      </div>
      <div class="company-name-email f1 df fdc jcc">
        <p>{{ $store.getters.userData.companyName }}</p>
        <p>{{ $store.getters.userData.companyWebsite }}</p>
      </div>
      <div class="plan-info df fdc jcc">
        <p>Plan</p>
        <p>{{ myPlan() }}</p>
      </div>
    </div>
    <div class="company-info-bottom f1 df fdc">
      <div class="info-row">
        <span>
          <p>Company Type</p>
          <p>{{ $store.getters.userData.companyType }}</p>
        </span>
        <span>
          <p>Blended Rate</p>
          <p>${{ $store.getters.userData.companyRate }}/h</p>
        </span>
        <span>
          <p>Average Cost</p>
          <p>${{ $store.getters.userData.companyContingency }}/h</p>
        </span>
        <!-- <span>
          <p>Cost</p>
          <p>{{ $store.getters.userData.companyCost }}%</p>
        </span> -->
      </div>
      <div class="info-row">
        <span>
          <p>Projects</p>
          <p>{{ numberOfProjects() }}</p>
        </span>
        <span>
          <p>Projects Closed</p>
          <p>{{ numberOfProjectsClosed() }}</p>
        </span>
        <span>
          <p>Avg Price</p>
          <p>{{ averageProjectCost() }}</p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // import Login from '../components/Login'

  name: 'CompanyInfo',
  data () {
    return {
      selectedPriceRange: 'mid',
      myProjectDetailsList: this.$store.getters.myProjectListWithDetails,
      myProjectDetailsListFull: this.$store.getters.myProjectListWithDetailsFull
    }
  },
  props: [],
  components: {

  },
  methods: {
    myPlan () {
      if (this.$store.getters.companyPlan.toLowerCase() == 'free') {
        return 'Free'
      } else if (this.$store.getters.companyPlan == 'plan_G91cFxeIzg5lCq') {
        return 'Unlimited'
      } else if (this.$store.getters.companyPlan == 'plan_G91aW03VrSu7x8') {
        return 'Basic'
      }
    },
    numberOfProjects () {
      return Object.keys(this.$store.getters.myProjectList).length
    },
    numberOfProjectsClosed () {
      var projects = this.$store.getters.myProjectListWithDetails
      var total = 0

      for (var project in projects) {
        if (projects[project].status == 'closed') {
          total = total + 1
        }
      }

      return total
    },
    averageProjectCost () {
      var projects = this.$store.getters.myProjectListWithDetails
      var total = 0

      for (var project in projects) {
        // if (projects[project].status == 'closed') {
          total = total + this.totalPriceSum(project)
        // }
      }

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })

      total = total/this.numberOfProjects()

      return formatter.format(total) // "$1,000.00"

      // console.log("TOTAL PROJECT COST", total)
      // return total
    },
    totalPriceSum (projectKey) {
      var priceTotal = 0

      for (var module = 0; module < (this.myProjectDetailsListFull[projectKey] && (this.myProjectDetailsListFull[projectKey].modules ? this.myProjectDetailsListFull[projectKey].modules.length : 0)); module = module + 1) {
        // console.log('module', module)
        priceTotal = parseFloat(priceTotal) + parseFloat(this.priceSumModule(projectKey, module))
      }

      // priceTotal = priceTotal + (priceTotal * this.myProjectDetailsListFull[projectKey] ? this.myProjectDetailsListFull[projectKey].contingency/100 : 0)
      for (var override in (this.myProjectDetailsListFull[projectKey] && this.myProjectDetailsListFull[projectKey].overrides)) {
        if (this.myProjectDetailsListFull[projectKey].overrides[override].type == 'percent') {
          priceTotal = priceTotal + priceTotal * (this.myProjectDetailsListFull[projectKey].overrides[override].value / 100)
        } else {
          priceTotal = priceTotal + parseFloat(this.myProjectDetailsListFull[projectKey].overrides[override].value)
        }
        // console.log('OVERRIDE', this.myProjectDetailsListFull[projectKey].overrides[override])
      }

      console.log('priceTotal', priceTotal)
      return priceTotal
    },
    priceSumModule (projectKey, keyVal) {
      var moduleSum = 0
      // console.log('xx', keyVal)
      // console.log('yy', this.$store.getters.currentProjectModules)
      for (var component in this.myProjectDetailsListFull[projectKey].modules[keyVal].components) {
        // console.log('module', component)
        var amount = this.priceSumComponent(keyVal, component, projectKey)
        amount = amount.replace(/\$|,/g, '')
        moduleSum = parseFloat(moduleSum) + parseFloat(amount)
        // console.log('amount', amount, moduleSum)
      }
      console.log('moduleSum', moduleSum)
      return moduleSum.toFixed(2)
    },
    priceSumComponent (key, key2, projectKey) {
      var componentTotal = 0
      var hoursTotal = 0
      var rate = this.myProjectDetailsListFull[projectKey].blendedRate
      var contingency = this.myProjectDetailsListFull[projectKey].contingency
      var overrides = this.myProjectDetailsListFull[projectKey].overrides || []
      var modules = this.myProjectDetailsListFull[projectKey].modules
      var columns = this.myProjectDetailsListFull[projectKey].moduleColumns
      var totalPercent = 0

      var module = key
      var component = key2

      var quantity = modules[module].components[component].moduleColumns.metaElements[modules[module].components[component].moduleColumns.metaElements.length - 1][this.selectedPriceRange]
      if (modules[module].components[component].disabled == true) {
      }
      else {
        for (var element in modules[module].components[component].moduleColumns.hourlyElements) {
          if (columns.hourlyElements[element].disabled == true) {
          } else {
            var hours = modules[module].components[component].moduleColumns.hourlyElements[element][this.selectedPriceRange]
              if ((columns.hourlyElements[element] ? columns.hourlyElements[element].hourlyRateOverride : false) && columns.hourlyElements[element].useTaskRate == true) {
                // console.log('hours', hours)
                componentTotal = componentTotal + quantity * hours * columns.hourlyElements[element].hourlyRateOverride
              } else {
                componentTotal = componentTotal + quantity * hours * rate
              }
          }
        }

        // for (var element in modules[module].components[component].moduleColumns.percentTasks) {
        for (var element in modules[module].components[component].moduleColumns.percentTasks) {
          if (columns.percentTasks[element].disabled == true) {
          } else {
            var percent = 0
            if (columns.percentTasks[element].hourlyRateOverride && columns.percentTasks[element].useTaskRate) { // override exists && use override == true
              var _p = 0

              if (modules[module].components[component].moduleColumns.percentTasks[element][this.selectedPriceRange]) {
                _p = modules[module].components[component].moduleColumns.percentTasks[element][this.selectedPriceRange]
              } else if (columns.percentTasks[element].taskPercentOverride) {
                _p = columns.percentTasks[element].taskPercentOverride
              }

              percent = hoursTotal * columns.percentTasks[element].hourlyRateOverride * _p / 100
            } else if (modules[module].components[component].moduleColumns.percentTasks[element] ? modules[module].components[component].moduleColumns.percentTasks[element][this.selectedPriceRange] : false) {

              var _p = 0

              if (modules[module].components[component].moduleColumns.percentTasks[element][this.selectedPriceRange]) {
                _p = modules[module].components[component].moduleColumns.percentTasks[element][this.selectedPriceRange]
              } else if (columns.percentTasks[element].taskPercentOverride) {
                _p = columns.percentTasks[element].taskPercentOverride
              }

              percent = hoursTotal * rate * _p / 100
            } else {
              if (columns.percentTasks[element].taskPercentOverride) {
                _p = columns.percentTasks[element].taskPercentOverride
                percent = hoursTotal * rate * _p / 100
              }
            }

            // console.log('adding %', percent)
            totalPercent = totalPercent + percent
          }
        }
        // componentTotal = componentTotal * (1 + (totalPercent/100))
        componentTotal = componentTotal + totalPercent

        for (var element in modules[module].components[component].moduleColumns.fixedElements) {
          if (columns.fixedElements[element].disabled == true) {
          } else {
            var amount = modules[module].components[component].moduleColumns.fixedElements[element][this.selectedPriceRange]
            componentTotal = componentTotal + quantity * amount
          }
        }
      }

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })

      console.log('componentTotal', componentTotal)

      return formatter.format(componentTotal) // "$1,000.00"
      // return 20
      // return componentTotal.toFixed(2) // module, component
    },
    totalPrice(projectKey) {
      var x = this.myProjectDetailsListFull[projectKey]
      console.log('xxxxxxyyyy', x)
      var totalPrice = 0

      var rate = this.myProjectDetailsListFull[projectKey].blendedRate
      var contingency = this.myProjectDetailsListFull[projectKey].contingency
      var overrides = this.myProjectDetailsListFull[projectKey].overrides

      var modules = this.myProjectDetailsListFull[projectKey].modules
      var columns = this.myProjectDetailsListFull[projectKey].moduleColumns

      for (var module in modules) {
        for (var component in modules[module].components) {
          var componentTotal = 0
          var fixedTotal = 0
          var totalPercent = 0
          var quantity = modules[module].components[component].moduleColumns.metaElements[modules[module].components[component].moduleColumns.metaElements.length - 1]

          for (var element in modules[module].components[component].moduleColumns.hourlyElements) {
            var hours = modules[module].components[component].moduleColumns.hourlyElements[element]['mid']
            if (columns.hourlyElements[element] ? columns.hourlyElements[element].hourlyRateOverride : false) {
              componentTotal = componentTotal + (hours * columns.hourlyElements[element].hourlyRateOverride)
            } else {
              componentTotal = componentTotal + (hours * rate)
            }
          }

          for (var element in modules[module].components[component].moduleColumns.fixedElements) {
            var amount = modules[module].components[component].moduleColumns.fixedElements[element]['mid']
            fixedTotal = fixedTotal + amount
          }

          for (var element in modules[module].components[component].moduleColumns.percentTasks) {
            var percent = modules[module].components[component].moduleColumns.percentTasks[element]['mid']
            totalPercent = totalPercent + percent
          }

          // console.log('totalPercent', quantity['mid'])
          totalPrice = totalPrice + ((componentTotal * (1 + (totalPercent/100))) + fixedTotal) * quantity['mid']
        }
      }

      totalPrice = totalPrice * (1 + (this.myProjectDetailsListFull[projectKey].contingency/100))

      for (var override in this.myProjectDetailsListFull[projectKey].overrides) {
        if (this.myProjectDetailsListFull[projectKey].overrides[override].type == 'fixed') {
          totalPrice = totalPrice + parseFloat(this.myProjectDetailsListFull[projectKey].overrides[override].value)
        } else if (this.myProjectDetailsListFull[projectKey].overrides[override].type == 'percent') {
          totalPrice = totalPrice * (1 + (parseFloat(this.myProjectDetailsListFull[projectKey].overrides[override].value)/100))
        }
      }

      // console.log('totalPrice', totalPrice)
      // return totalPrice

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })

      // formatter.format(1000) // "$1,000.00"

      return formatter.format(totalPrice)
      // return totalPrice.toFixed(2).toString()
      // return '500'
    },
  },
  computed: {

  },
  created () {
    console.log('** COMPANY INFO Component Loaded', this.$store.getters.myProjectList)
    console.log(this.averageProjectCost())
  }
}
</script>

<style scoped lang="scss">
.box > div {
  padding: 40px;
}

.company-info-top {
  border-radius: 9px 9px 0 0;
  background-color: #D9EDFF;
}

.company-name-email {
  padding-left: 40px;

  & > p {
    &:first-child {
      margin-top: 25px;
      color: #000000;
      font-size: 30px;
      font-weight: 500;
      line-height: 19px;
    }
    &:nth-child(2) {
      margin-top: 10px;
      color: #232E37;
      font-size: 14px;
      font-weight: 500;
      line-height: 19px;
    }
  }
}

.info-row {
  font: 1px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 50px;

  & > span {
    flex: 1px;
    & > p {
      &:first-child {
        color: #000000;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0.5px;
        line-height: 25px;
      }
      &:nth-child(2) {
        color: #000000;
        font-size: 24px;
        line-height: 25px;
      }
    }
  }
}

.company-info-bottom {
}

.plan-info {
  & > p {
    &:first-child {
      color: #000000;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.5px;
      line-height: 19px;
    }
    &:nth-child(2) {
      color: #000000;
      font-size: 36px;
      line-height: 42px;
    }
  }
}

.company-logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
  object-position: center;
}
</style>
